import OneSignal from "react-onesignal";

let started = false;

// Initialise the OneSignal Web SDK once and bind the logged-in user via external_id.
export async function initOneSignal(userId) {
  const appId = process.env.REACT_APP_ONESIGNAL_APP_ID;
  if (!appId) return;
  if (started) {
    if (userId) { try { await OneSignal.login(String(userId)); } catch { /* ignore */ } }
    return;
  }
  started = true;
  try {
    await OneSignal.init({
      appId,
      safari_web_id: process.env.REACT_APP_ONESIGNAL_SAFARI_WEB_ID || undefined,
      notifyButton: { enable: false },
      allowLocalhostAsSecureOrigin: true,
    });
    if (userId) { try { await OneSignal.login(String(userId)); } catch { /* ignore */ } }
  } catch (e) {
    // Init can fail when the domain does not match the OneSignal site URL; keep the app working.
    console.warn("OneSignal init skipped:", e?.message || e);
  }
}

// Prompt the browser push permission (used by the Settings toggle).
export async function promptNotifications() {
  try {
    if (OneSignal?.Slidedown?.promptPush) {
      await OneSignal.Slidedown.promptPush();
    } else if (OneSignal?.Notifications?.requestPermission) {
      await OneSignal.Notifications.requestPermission();
    }
    return true;
  } catch (e) {
    console.warn("promptNotifications failed:", e?.message || e);
    return false;
  }
}
